import { Component } from "@angular/core";

@Component({
    selector: "adapt-root",
    templateUrl: "./app.component.html",
    standalone: false,
})
export class AppComponent {
    public title = "outlook-addin";
}
